import { cityTranslations } from "../constants";

export const getTranslatedCity = (city, language = "en") => {
  if (!city) {
    return "N/A";
  }

  if (language === "en") {
    return city;
  }

  return (cityTranslations[city] && cityTranslations[city][language]) || city;
};
